import React from 'react';
import {createRoot} from 'react-dom/client';
import {Application, Cookies, LocalEventsManager} from "core";
import {Settings} from "settings";
import {CustomNotification, ImageUploader} from "controls";
import {Api, State, Utils} from "tools";
import moment from "moment";
import {UserRouter} from "./bundleDescription";
import {NavigationAction} from "framework/navigationStore"
import {NavigationStore} from "framework/navigationStore";
import {AdministrationRouter} from "areas/administration/bundleDescription";
import {ManagementRouter} from "areas/management/bundleDescription";
import {ApplicationState} from "framework/applicationState";
import {UserConfiguration} from "./user-configuration/userConfiguration";
import { UserConfigurationStore } from './user-configuration/userConfigurationStore';
import { cloneDeep } from 'lodash';
import { HomeTabType } from 'areas/summary/types';
import { i18n } from 'core/localization';
import { ADMIN_USER_ID } from './user-configuration/constants';
import './userDetails.less';
let UserDetails = function (config) {
	Utils.apply(this, config);
	this.mode ||= this.id ? 'update' : 'create';
	this.recentlyUsedIcons = [];
	this.userPref = [];
	this.module = {
		name: 'UserDetails',
		initialConfig: config
	};
	this.needReload = false;
	this.isUserProfile = this.id === Cookies.CeesoftUserId;

	this.accountContext = this.isUserProfile ? Cookies.CeesoftAccountId : Cookies.CeesoftCurrentAccountId;

	if (this.id === ADMIN_USER_ID) {
		this.isAdmin = true;
	}

	this.langLocale = (ApplicationState.locale === 'no' ? 'nb' : 'en');
	moment.locale(this.langLocale);
	this.initComponent();
};

export default UserDetails;

jQuery.extend(UserDetails.prototype, Application.prototype, {
	initComponent: async function () {
		this.update = true;
		let title;

		if (!State.mainApp.session.hasRole('USER_UPDATE') && (!this.isUserProfile || !State.mainApp.session.hasRole('USER_PROFILE')) && this.mode !== 'view') {
			this.mode = 'view';
		}
		if (this.mode === 'view') {
			this.update = false;
		}

		if(!this.id) {
			$('.cw_notification_rules_tab').addClass('hide');
			$('#save_user').text(i18n('Create'));
			title = i18n('New');
		}

		Application.prototype.initComponent.call(this);

		if (this.id) {
			Cookies.create("CeesoftViewUserId", this.id, Settings.COOKIE_TIMEOUT);
		}

		this.dateTimeFormat = Cookies.CeesoftUserDateTimeFormat;
		this.dateFormat = Cookies.CeesoftUserDateFormat;
		this.timeFormat = Cookies.CeesoftUserTimeFormat;

		this.removeListeners();
		this.attachListeners();

		this.statusNotification = new CustomNotification({
			appendToElement: '.window_area',
			style: 'top:50px;left:10px;right:10px',
			status: 'success',
			type: 'icon',
			hideOnClick: true
		});

		this.tabStrip = $('#cw_profile_notifications').kendoTabStrip({
			animation: false,
			activate: $.proxy(this.onTabActivate, this),

		}).data('kendoTabStrip');

		let initialTab = $('.cw_profile_tab');
		if(this.selectedTab) {
			initialTab = $(`[data-tab=${this.selectedTab}]`);
		}

		this.tabStrip.activateTab(initialTab);

		this.removeMask();
		if (this.mode === 'view') {
			$('#cw_user_card_avatar').addClass('disabled');
			$('#save_user').addClass('hide');
		}

		if(this.id) {
			await this.load();
			title ||= this.userDetails?.username || i18n('Profile');
		}

		this.initNewForm();

		this.initialized({title});
	},

	getInitialUser() {
		const user = cloneDeep(this.userDetails) ?? {};

		if(this.mode === 'create') {
			user.landingPages = [HomeTabType.HOME_VIEW];
			user.locale = Cookies.CeesoftUserLocale;
			user.timeZone = Cookies.CeesoftTimezone;
			user.lockUser = false;
			user.changePassword = false;
			user.forceTeamTags = false;
			user.forceUserTags = false;
			user.teams = [];
			user.tags = [];
		}

		user.loginAccountId ||= this.accountContext;
		if(this.mode !== 'create') {
			user.dateTimeFormat ||= this.dateTimeFormat;
			user.dateFormat ||= this.dateFormat;
			user.timeFormat ||= this.timeFormat;
		}
		user.password = '';
		user.passwordConfirm = '';
		user.oldPassword = '';

		return user;
	},

	initNewForm() {
		const initialUser = this.getInitialUser();
		this.newUserDetails = cloneDeep(initialUser);
		this.userConfigurationStore = new UserConfigurationStore({
			user: initialUser,
			accountContext: this.accountContext,
			onChange: this.processChanges.bind(this),
			onValidChange: (valid) => $('#save_user').attr('disabled', !valid),
			mode: this.mode
		});
		let container = $('.user-configuration')[0];
		this.reactFormContainerRoot = createRoot(container);
		this.reactFormContainerRoot.render(<UserConfiguration store={this.userConfigurationStore}/>);
		this.processChanges(this.newUserDetails);
	},

	processChanges(newValue) {
		this.newUserDetails = newValue;
		this.updateLiveElements();
	},

	updateLiveElements() {
		$('#card_firstname').text(this.newUserDetails.firstName || i18n('First name'));
		$('#card_lastname').text(this.newUserDetails.lastName || i18n('Last name'));
		$('#card_email').text(this.newUserDetails.email || i18n('Email'));
		$('#card_username').text(this.newUserDetails.username || i18n('Username'));
	},
	/**
	 * Handler function for tab activating
	 * @param {Object} e The activate event
	 */
	onTabActivate: function (e) {
		var tab = $(e.item).data('tab');
		switch (tab) {
			case 'rules':
				this.destroy();
				$('#content_area').empty();
				State.mainApp.navigate(UserRouter.ruleset(this.id), {
					navigationAction: NavigationAction.PopOne
				});
				break;
		}

		if (this.mode === 'view') {
			$('#save_user').addClass('hide');
		}
	},
	/**
	 * Called in order to remove existing listeners
	 */
	removeListeners: function () {
		$('#cancel').off();
		$('.cw_avatar_user').find('.close_minibtn').off();
		$('.cw_media_library').off();
		$('#save_user').off();
		$('#save_avatar').off();
		LocalEventsManager.unbind('loadRecentIcons');
	},
	/**
	 * Attaches the listeners
	 */
	attachListeners: function () {
		$('#save_user').on('click', $.proxy(this.onSaveButton, this));
		$('#cancel').on('click', $.proxy(this.onDetailsCancel, this));
		$('.cw_avatar_user').find('.close_minibtn').on('click', $.proxy(this.onRemovePicture, this));
		$('.cw_media_library').on('click', $.proxy(this.onMediaLibraryButton, this));

		LocalEventsManager.bind('loadRecentIcons', $.proxy(this.loadRecentIcons, this));
	},
	/**
	 * Launches Media Library.
	 */
	onMediaLibraryButton: function () {
		if ($('.cw_media_library_content').hasClass('hide')) {
			if (!this.uploaderImagesControl) {
				this.renderUploaderImagesControl();
				//TODO: not sure if this is still relevant because the way of getting image is changed
				// if (this.pictureId) {
				// 	this.uploaderImagesControl.setSelectedImageId(this.pictureId);
				// }
			}
			$('.form_content_minimal').show();
			$('.cw_media_library_content').removeClass('hide');
			$('.cw_media_library').addClass('hide');
		}
	},
	/**
	 * Renders the uploader images control.
	 */
	renderUploaderImagesControl: function () {
		this.uploaderImagesControl = new ImageUploader({
			id: 'user_glyph_icons',
			livePreviewSelector: '#cw_user_card_avatar',
			width: '100%',
			height: '344px',
		});
	},
	/**
	 * Loads the form data from the server and renders the avatar
	 */
	load: async function () {
		var loadUrl = Settings.serverPath + 'accounts/' + this.accountContext + '/users/' + this.id + '/?update=' + this.update,
			oThis = this;
		$('#save_user').text(i18n('Update'));
		const result = await Utils.ajax(loadUrl, 'GET', {});
		if (result.success) {
			this.userDetails = result.data;
			this.pictureId = result.data.pictureId;
			this.iconPack = result.data.iconPack;
			var imagePreviewDiv = $('#cw_user_card_avatar .cw_avatar_user');
			if (Utils.isGuid(this.pictureId)) {
				imagePreviewDiv.addClass('no_bg');
				imagePreviewDiv.prepend('<img src="' + Api.users.urls.avatar(oThis.id, this.pictureId, this.accountContext) + '" />');
			} else if (this.pictureId) {
				imagePreviewDiv.addClass('no_bg');
				if (this.iconPack === 'glyph') {
					imagePreviewDiv.prepend('<span class="glyphicons ' + this.pictureId + '">');
				} else {
					imagePreviewDiv.prepend('<i class="material-icons">' + this.pictureId + '</i>');
				}
			}
		} else {
			Utils.showInfo(i18n('Alert'), result.message, result.details);
		}
	},
	/*
	 * Handler function for updating the cookies
	 * */
	updateCookies: function () {
		var timeout = Settings.COOKIE_TIMEOUT;
		Cookies.create("CeesoftTimezone", this.timeZone, timeout);
		Cookies.create("CeesoftUserLocale", this.locale, timeout);
		Cookies.erase("CeesoftUserDateTimeFormat");
		Cookies.erase("CeesoftUserDateFormat");
		Cookies.erase("CeesoftUserTimeFormat");
		Cookies.erase("CeesoftUserPictureId");
		Cookies.create("CeesoftUserDateTimeFormat", this.dateTimeFormat, timeout);
		Cookies.create("CeesoftUserDateFormat", this.dateFormat, timeout);
		Cookies.create("CeesoftUserTimeFormat", this.timeFormat, timeout);
		Cookies.create("CeesoftUserPictureId", this.pictureId, timeout);
		ApplicationState.loadStateFromCookies();
	},
	/**
	 * Callback function that handles the save response
	 * @param {Object} result
	 */
	onDataSuccessfullySaved: function (result) {
		if (result.success) {
			var timeout = Settings.COOKIE_TIMEOUT;
			var email = this.newUserDetails.email;
			if (email) {
				Cookies.erase("CeesoftUserEmail");
				Cookies.create("CeesoftUserEmail", email, timeout);
			}
			this.pictureId = result.data.pictureId;
			this.iconPack = result.data.iconPack;
			if (this.id === Cookies.CeesoftUserId) {
				this.updateCookies();
			}
			if (!Utils.isGuid(result.data.pictureId)) {
				for (var i = 0; i < this.recentlyUsedIcons.length; i++) {
					if (this.pictureId === this.recentlyUsedIcons[i].id) {
						this.recentlyUsedIcons.splice(i, 1);
					}
				}
				this.recentlyUsedIcons.unshift({
					id: this.pictureId,
					iconPack: this.iconPack
				});
				if (this.recentlyUsedIcons.length === 9) {
					this.recentlyUsedIcons.pop();
				}
				var preferences = [{
					key: 'recentIcons',
					value: JSON.stringify(this.recentlyUsedIcons)
				}];
				this.saveUserPrefs({
					category: 'RecentlyUsedIcons',
					preferences: preferences
				});
			}

			this.navigateBack();
			this.destroy();

			if (this.needReload) {
				window.location.reload();
			}

		} else {
			this.statusNotification.setOptions({
				message: result.message,
				status: 'error'
			}).show();
		}
	},

	/**
	 * Handler function for the click event on image remove button
	 */
	onRemovePicture: function (e) {
		var userModal, id, previewDiv;
		if (this.uploaderImagesControl.getSelectedImage().id) {
			//TODO: not sure if this is still relevant because the way of getting image is changed
			//this.uploaderImagesControl.setSelectedImageId('');
			userModal = $(e.target).parents().eq(6);
			id = userModal.find('.userId').attr('id');
			// remove on modal
			previewDiv = userModal.find('.cw_avatar_user');
			previewDiv.find('.close_minibtn').addClass('hide');
			previewDiv.removeClass('no_bg');
			previewDiv.find('img, span, i').remove();
		}
	},
	/**
	 * Handler function for the click event on Save button
	 * @param {Object} e The click event
	 */
	onSaveButton: async function (e) {
		const user = this.newUserDetails;
		let name = user.username?.trim();
		if(name) {
			name = name.toUpperCase();
			let searchUrl = Api.accountRoot() + 'users/lite?name=';
			let nameExists = await Utils.checkIfNameExists(searchUrl, name, this.statusNotification, true, this.userDetails?.username);
			if(nameExists) {
				return;
			}
		}

		const validation = this.userConfigurationStore.validate();
		if (!validation.isValid) {
			this.statusNotification.setOptions({
				message: validation.message,
				status: 'error'
			}).show();
			return;
		}

		this.timeZone = user.timeZone;
		this.locale = user.locale;
		this.needReload = Cookies.CeesoftUserLocale != this.locale;
		this.dateTimeFormat = user.dateTimeFormat;
		this.dateFormat = user.dateFormat;
		this.timeFormat = user.timeFormat;

		this.data = {
			id: (this.id === 'new_user' ? null : this.id),
			username: user.username.trim(),
			locale: this.locale,
			timeZone: this.timeZone,
			dateTimeFormat: this.dateTimeFormat,
			dateFormat: this.dateFormat,
			timeFormat: this.timeFormat,
			firstName: user.firstName.trim(),
			lastName: user.lastName.trim(),
			email: user.email.trim(),
			phoneNumber: user.phoneNumber,
			teams: user.teams || [],
			tags: user.tags,
			loginAccountId: user.loginAccountId || this.accountContext,
			landingPages: user.landingPages,
			forceTeamTags: user.forceTeamTags,
			forceUserTags: user.forceUserTags,
			externallyManaged: user.externallyManaged,
			password: user.password || ''
		};

		if (this.id === Cookies.CeesoftUserId) {
			this.data.oldPassword = user.oldPassword;
			this.data.lockUser = null;
		} else {
			this.data.lockUser = !!user.lockUser;
			this.data.changePassword = !!user.changePassword;
		}

		if (!this.isAdmin) {
			this.data.userCategoryId = user.userCategoryId;
		}

		if (this.uploaderImagesControl) {
			this.data.pictureId = this.uploaderImagesControl?.getSelectedImage()?.id || '';
			this.data.iconPack = this.uploaderImagesControl?.getSelectedImage()?.iconPack || '';
		} else {
			this.data.pictureId = this.pictureId;
			this.data.iconPack = this.iconPack;
		}

		const urlCreate = Settings.serverPath + 'accounts/' + this.accountContext + '/users/createUser';
		const urlUpdate = Settings.serverPath + 'accounts/' + this.accountContext + '/users/' +
			(this.id === Cookies.CeesoftUserId ? 'updateProfile' : 'updateUser');
		const url = (this.mode === 'create' ? urlCreate : urlUpdate);
		Utils.ajax(url, 'POST', JSON.stringify(this.data), $.proxy(this.onDataSuccessfullySaved, this));
	},
	/**
	 * Handler for the cancel button in the expanded summary section
	 */
	onDetailsCancel: function (e) {
		this.navigateBack();
	},

	// recovered broken logic
	navigateBack: function () {
		if (this.isFromUsersGrid) {
			NavigationStore.go(AdministrationRouter.listUsers());
		} else if (this.isFromManagementUsersGrid) {
			NavigationStore.go(ManagementRouter.activeUsers());
		} else if (this.mode === 'create') {
			NavigationStore.go(AdministrationRouter.listUsers());
		} else {
			NavigationStore.pop();
		}
	},
	/**
	 * Handler for the cancel cw_avatar button click
	 */
	onAvatarCancel: function (e) {
		$('.form_content_minimal').hide();
		$('.cw_media_library_content').addClass('hide');
	},
	destroy: function () {
		Application.prototype.destroy.call(this);
		this.removeListeners();
		this.uploaderImagesControl?.destroy();
		this.reactFormContainerRoot?.unmount();
		this.reactFormContainerRoot = null;
		this.userConfigurationStore?.destroy();
	},
	/**
	 * Loads recent icons
	 * @param {Object} e The object sent by event manager
	 */
	loadRecentIcons: function (e) {
		this.recentlyUsedIcons = e.recentIcons;
	}
});
